// import { createMuiTheme } from '@mui/material/styles';
// import { amber } from '@mui/material/colors';

// const config = [{'address' : 'http://chapargps1362.pythonanywhere.com', 'group_show': 0,}];
// const config = [{'address' : 'http://192.168.1.30:3030', 'group_show': 0,}];
// const config = [{'address' : 'http://192.168.1.104:8080', 'group_show': 0,}];
// const config = [{'address' : 'https://teknokey.iran.liara.run', 'group_show': 0,}];
// const config = [{'address' : 'http://localhost:8080', 'group_show': 0,}];
const config = [{
    'address' : 'https://api.etec.ir', 
    // 'address' : 'http://127.0.0.1:8000', 
    'group_show': 0,
    site_key: '6LfFshYpAAAAAK4EZ5CiOL4bIgcxgts9PiQxqDwC',
    secrer_key : '6LfFshYpAAAAAOa8bWqvzfx0Q0mAwqf6odTfsWJL'
}];

export default config